export default "__VITE_ASSET__3db95eb9__"